/* So.lab · masque la pastille cookies (Pandectes) une fois que la personne a fait son choix.
   La bannière reste disponible : un lien vers [data-solab-cookies] (ou #cookies) la rouvre. */
(function () {
  var STYLE_ID = 'solab-hide-cookie-widget';

  function decided() {
    var m = document.cookie.match(/(?:^|;\s*)_pandectes_gdpr=([^;]*)/);
    if (!m) return false;
    var raw = decodeURIComponent(m[1]);
    var data = null;
    try { data = JSON.parse(atob(raw)); } catch (e) { try { data = JSON.parse(raw); } catch (e2) { return false; } }
    if (!data || !data.status) return false;
    return !data.method || data.method === 'explicit';
  }

  function hide() {
    var done = false;
    document.querySelectorAll('pandectes-cmp').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root) return;
      done = true;
      if (root.getElementById(STYLE_ID)) return;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = '.widget{display:none!important}';
      root.appendChild(style);
    });
    return done;
  }

  function check() {
    if (decided()) return hide();
    return false;
  }

  /* Au chargement : la pastille arrive après coup, on réessaie quelques secondes */
  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    if (check() || tries > 50) clearInterval(timer);
  }, 300);

  /* Juste après le clic sur Accepter / Refuser */
  document.addEventListener('visitorConsentCollected', function () { setTimeout(check, 300); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('pandectes-cmp')) setTimeout(check, 600);
    var link = e.target.closest && e.target.closest('[data-solab-cookies], a[href="#cookies"]');
    if (link) {
      e.preventDefault();
      var btn = null;
      document.querySelectorAll('pandectes-cmp').forEach(function (host) {
        if (!btn && host.shadowRoot) btn = host.shadowRoot.querySelector('.widget');
      });
      if (btn) btn.click();
    }
  }, true);
})();
